// eslint-disable-next-line import/no-mutable-exports
let config;
if (process.env.NODE_ENV === 'production' || process.env.webpackEnv === 'production') {
  // eslint-disable-next-line global-require
  config = require(`./env/production`);
} else if (
  process.env.ENV === 'staging' ||
  process.env.NODE_ENV === 'staging' ||
  process.env.webpackEnv === 'staging'
) {
  // eslint-disable-next-line global-require
  config = require(`./env/staging`);
} else {
  // eslint-disable-next-line global-require
  config = require(`./env/development`);
}

module.exports = config;
